var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import SubscriberV2Resources from "@ane/exp-data/lib/resources/SubscriberV2Resources";
import { RestResult } from "@ane/core/lib/services/RestServiceBase";
const prefix = "LOAD_SUBSCRIBERS_V2";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["items"],
  loadResource: (payload) => __async(void 0, null, function* () {
    if (!payload.notificationCategory) {
      return SubscriberV2Resources.loadSubscribers(payload);
    } else {
      const [result, adminSubscribersResult] = yield Promise.all([
        SubscriberV2Resources.loadSubscribers(payload),
        SubscriberV2Resources.loadAdminSubscribers(payload.workspaceId, payload.notificationCategory, 0, 1e3)
      ]);
      let entitySubscribers = result.getSuccessData().value;
      let adminSubscribers = adminSubscribersResult.getSuccessData().value;
      let mergedSubscribers = entitySubscribers.concat(adminSubscribers);
      let newResult = {
        value: mergedSubscribers,
        nextLink: adminSubscribersResult.getSuccessData().nextLink
      };
      return RestResult.fromResult(newResult);
    }
  }),
  onCompleteSuccess: (result, inputPayload) => {
    return result;
  }
};
const loadSubscribersEpicReducerV2 = loadResourcesUtils(args);
const LoadSubscribersV2_epics = combineEpics(loadSubscribersEpicReducerV2.epic);
export {
  LoadSubscribersV2_epics as default,
  loadSubscribersEpicReducerV2
};
//# sourceMappingURL=LoadSubscribersV2.epics.js.map
